import CreateKeyFactor from "@/app/dto/CreateKeyFactor";

export default class AuthorizationKeyRequest {
    usedFactors: CreateKeyFactor[];
    checkAccountBlocking: boolean;

    constructor(sendOtp: boolean) {
        this.usedFactors = [new CreateKeyFactor(sendOtp)];
        this.checkAccountBlocking = true;
    }

}
